import React from 'react';
import { AssessmentQuestionType } from '../../utils/assessmentsQuestions';
import TextInputGradingCard from './TextInputGradingCard';
import MultipleChoiceGradingCard from './MultipleChoiceGradingCard';
import FileUploadGradingCard from './FileUploadGradingCard';
import { GradingQuestion } from './GradingQuestionType';
import { GradingQuestionAction } from './GradingQuestionReducer';

interface GradingCardRendererProps {
  data: GradingQuestion
  dispatch: React.Dispatch<GradingQuestionAction>
  isViewMode?: boolean
}

const GradingCardRenderer: React.FC<GradingCardRendererProps> = ({
  data,
  dispatch,
  isViewMode = false
}) => {
  const {type} = data
  if (type === AssessmentQuestionType.TextInput) {
    return (
      <TextInputGradingCard
      data={data}
      dispatch={dispatch}
      isViewMode={isViewMode}
      />
    );
  } else if (type === AssessmentQuestionType.MultipleChoice || type === AssessmentQuestionType.SingleChoice) {
    return (
      <MultipleChoiceGradingCard
      data={data}
      dispatch={dispatch}
      isViewMode={isViewMode}
      />
    );
  } else if (type === AssessmentQuestionType.FileUpload) {
    return (
      <FileUploadGradingCard
      data={data}
      dispatch={dispatch}
      isViewMode={isViewMode}
      />
    );
  }
  return <div>N/A</div>;
};

export default GradingCardRenderer;
